import { useEffect, useRef } from "react";
import { Row, Col } from "antd";
import { Link } from "react-router-dom";

import aparta from "../../assets/images/2025/Logos_Botones_Iconos/casaduana_ApartaLugar.svg";

import img_1 from "../../assets/images/2025/casaduana_objetivo01.jpg";
import img_2 from "../../assets/images/2025/casaduana_objetivo02.jpg";
import img_3 from "../../assets/images/2025/casaduana_objetivo03.jpg";

import "../../assets/css/style.css";

export default function AcercaDe() {
  const cuboRef = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          cuboRef.current.classList.add("cube-start");
        }
      },
      { threshold: 0.3 }
    );

    if (cuboRef.current) obs.observe(cuboRef.current);

    return () => obs.disconnect();
  }, []);

  return (
    <Row id="acerca-de" justify="center" className="acercade-wrapper" style={{ padding: "80px 0" }}>
      <Col xs={22} md={18}>
        <Row gutter={[40, 40]} align="middle">

          {/* TEXTO */}
          <Col xs={24} md={12}>
            <p className="acerca_home_titulo">
              Compliance aduanero, factor decisivo para el desafiante 2026
            </p>

            <p className="acerca_home_objetivo color_azul_claro">Objetivo</p>

            <p className="acerca_home_texto">
              Conoce las últimas modificaciones a las RGCE y demás normativa en materia de comercio exterior que impactarán en la operación aduanera. Así mismo, todas las actualizaciones entorno al fenómeno del nearshoring y el próximo presidente de los Estados Unidos y sus repercusiones en las operaciones de comercio exterior y que viene para este 2025 en el desarrollo de las cadenas de suministro.
            </p>

            <br />
            <Link to="#registro">
              <img src={aparta} alt="apartado" style={{ width: 180 }} />
            </Link>
          </Col>

          {/* CUBO 3D */}
          <Col xs={24} md={12}>
            <div className="cube-wrapper" ref={cuboRef}>
              <div className="cube">
                <div className="cube-face face-front">
                  <img src={img_1} alt="" />
                </div>
                <div className="cube-face face-right">
                  <img src={img_2} alt="" />
                </div>
                <div className="cube-face face-back">
                  <img src={img_3} alt="" />
                </div>
              </div>
            </div>
          </Col>

        </Row>
      </Col>
    </Row>
  );
}
